import axios from "axios";
import localforage from "localforage";


/**
 * @typedef WorkType
 *
 * @type {object}
 * @property {int} id
 * @property {string} description
 */
export default class WorkTypesRepository {
	static namespace = "WORK_TYPES";

	/**
	 * Get all work types
	 *
	 * @returns {Promise<Order[]>}
	 */
	static async getAll() {
		return (await localforage.getItem(this.namespace)) || [];
	}

	/**
	 * Download work types
	 *
	 */
	static async downloadData() {
		try {
			const response = await axios.get(`/work-types`);

			const workTypes = response.data;

			localforage.setItem(this.namespace, workTypes);
		} catch (error) {
			console.log("Couldn't refresh work types. Using local data.");
		}
	}
}